/**
 * Compares two arrays and returns true if they have the same members. Only for primitive values.
 */
export const sameArrayMembers = (arr1: unknown[], arr2: unknown[]): boolean => {
  return (
    arr1.length === arr2.length &&
    new Set([...arr1, ...arr2]).size === arr1.length
  );
};
